export default "__VITE_PUBLIC_ASSET__20fd7efc__"